import { withStyle } from 'styletron-react';
import { ModalHeader, ModalBody, ModalFooter } from 'baseui/modal';

export const createControllerModalOverrides = (width = 'auto') => ({
  Dialog: {
    style: ({ $theme }) => ({
      width: width,
      maxWidth: '90vw',
      maxHeight: '95vh',
      outline: `1px solid ${$theme.colors.borderOpaque}`,
      boxShadow: $theme.lighting.shadow600,
      overflowY: 'auto',
      backgroundColor: $theme.colors.backgroundPrimary,
    }),
  },
  Header: {
    component: withStyle(ModalHeader, ({ $theme }) => ({
      color: $theme.colors.contentPrimary,
    })),
  },
  Body: {
    component: withStyle(ModalBody, ({ $theme }) => ({
      color: $theme.colors.contentPrimary,
    })),
  },
  Footer: {
    component: withStyle(ModalFooter, ({ $theme }) => ({
      color: $theme.colors.contentPrimary,
    })),
  },
});

export const CustomTextareaOverrides = {
  Input: {
    style: (props) => ({
      minHeight: '150px',
      resize: 'vertical',
      backgroundColor: props.$theme.colors.inputFill,
      color: props.$theme.colors.contentPrimary,
      fontFamily: 'monospace',
      width: '100%',
    }),
  },
};

export const SettingsInputOverrides = {
  Input: {
    style: {
      textAlign: 'right',
      paddingRight: '16px',
    }
  },
  StartEnhancer: {
    style: ({ $theme }) => ({
      flexBasis: '160px',
      justifyContent: 'flex-start',
      backgroundColor: 'transparent',
    }),
  },
};